import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';

const Container = styled.section`
  background-color: #ededed;
  padding: 40px 0;
  position: relative;
  z-index: 2;
  clear: both;
  min-height: 664px;
  
  @media (max-width: 479px) {
    padding: 20px 0;
    min-height: auto;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
`;

const Title = styled.h2`
  color: #343434;
  font-size: 42px;
  font-family: 'Geologica', Arial, sans-serif;
  font-weight: 700;
  margin-bottom: 40px;
  
  @media (max-width: 479px) {
    font-size: 28px;
    margin-bottom: 30px;
  }
`;

const CountriesWrapper = styled.div`
  .tv-country {
    width: 100%;
    min-height: 500px;
  }
  
  @media (max-width: 479px) {
    .tv-country {
      overflow-x: auto;
    }
  }
`;

const CountriesPage = () => {
  const countriesRef = useRef(null);
  const scriptLoaded = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const hasReloaded = useRef(false);

  // Проверка на перезагрузку - выполняется только один раз
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('reload') === 'true' && !hasReloaded.current) {
      hasReloaded.current = true;
      
      // Удаляем параметр reload из URL без перезагрузки страницы
      searchParams.delete('reload');
      const newSearch = searchParams.toString();
      const newUrl = location.pathname + (newSearch ? `?${newSearch}` : '');
      
      // Обновляем URL без параметра reload
      navigate(newUrl, { replace: true });
      
      // Перезагружаем страницу
      window.location.reload();
    }
  }, [location, navigate]);

  useEffect(() => {
    let isMounted = true;
    const currentRef = countriesRef.current;

    // Функция загрузки скрипта Tourvisor
    const loadTourvisorScript = () => {
      return new Promise((resolve, reject) => {
        if (window.Tourvisor) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://tourvisor.ru/module/init.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    // Функция инициализации виджета
    const initWidget = () => {
      if (window.Tourvisor && currentRef && isMounted) {
        // Удаляем предыдущий виджет если был
        const existingWidget = currentRef.querySelector('.tv-country');
        if (existingWidget) {
          existingWidget.innerHTML = '';
        }
        
        // Создаем новый элемент виджета
        const widgetDiv = document.createElement('div');
        widgetDiv.className = 'tv-country tv-moduleid-9984452';
        currentRef.appendChild(widgetDiv);
        
        // Переинициализируем Tourvisor
        if (window.Tourvisor.reinit) {
          window.Tourvisor.reinit();
        }
      }
    };

    // Загружаем скрипт и инициализируем виджет
    if (!scriptLoaded.current) {
      scriptLoaded.current = true;
      loadTourvisorScript()
        .then(() => {
          // Даем время на загрузку
          setTimeout(() => {
            if (isMounted) {
              initWidget();
            }
          }, 500);
        })
        .catch(error => {
          console.error('Failed to load Tourvisor script:', error);
        });
    } else {
      initWidget();
    }

    // Очистка при размонтировании
    return () => {
      isMounted = false;
      if (currentRef) {
        const widget = currentRef.querySelector('.tv-country');
        if (widget) {
          widget.innerHTML = '';
        }
      }
    };
  }, []); // Пустой массив зависимостей - выполняется только один раз

  return (
    <Container>
      <Content>
        <Title>Страны</Title>
        <CountriesWrapper ref={countriesRef}>
          <div className="tv-country tv-moduleid-9984452"></div>
        </CountriesWrapper>
      </Content>
    </Container>
  );
};

export default CountriesPage;